import { Radio } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import styles from '../styles/Activity.module.scss';
type Props = {
  value: string;
  setValue?: (value: string) => void;
  naValue?: boolean;
  name: string;
  disabled?: boolean;
};

const RiskRadiobuttonGroup = ({ value, setValue, naValue, name, disabled }: Props) => {
  const { t } = useTranslation();

  const handleOptionChange = (e: any, { value }: Props) => {
    if (setValue) {
      setValue(value);
    }
  };

  return (
    <div className={styles.flexContainer}>
      <div className={styles.checkboxOption}>
        <Radio
          label={t('risk.assessment.details.page.risk.details.container.checkbox.yes')}
          name={name}
          value="yes"
          checked={value === 'yes'}
          onChange={handleOptionChange}
          disabled={disabled}
        />
      </div>
      <div className={styles.checkboxOption}>
        <Radio
          label={t('risk.assessment.details.page.risk.details.container.checkbox.no')}
          name={name}
          value="no"
          checked={value === 'no'}
          onChange={handleOptionChange}
          disabled={disabled}
        />
      </div>
      {naValue && (
        <div className={styles.checkboxOption}>
          <Radio
            label={t('risk.assessment.details.page.risk.details.container.checkbox.na')}
            name={name}
            value="na"
            checked={value === 'na'}
            onChange={handleOptionChange}
            disabled={disabled}
          />
        </div>
      )}
    </div>
  );
};

export default RiskRadiobuttonGroup;
